var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Treesponse_instances, _Treesponse_apiInterface, _Treesponse_create, _Treesponse_update;
export class Treesponse {
    constructor(apiInterface, treesponder, { language, surveyVersion }) {
        _Treesponse_instances.add(this);
        // General items
        _Treesponse_apiInterface.set(this, void 0);
        Object.defineProperty(this, "treesponder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Required attributes
        Object.defineProperty(this, "completed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "language", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "surveyVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Complex options
        Object.defineProperty(this, "answers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "results", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "pageVisits", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        // Basic attributes
        Object.defineProperty(this, "age", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "email", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "gender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "optinOrganisation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "optinProject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "postcode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "yearOfBirth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        __classPrivateFieldSet(this, _Treesponse_apiInterface, apiInterface, "f");
        this.treesponder = treesponder;
        this.language = language;
        this.surveyVersion = surveyVersion;
    }
    getAnswers() {
        return this.answers;
    }
    getAnswer(key) {
        return this.answers[key];
    }
    setAnswer(key, value) {
        // We first check if one of the answers is one of the special keys
        // If this is the case, we assume that the value has the correct type
        if (["age", "yearOfBirth"].includes(key)) {
            this[key] = value;
        }
        else if (["optinOrganisation", "optinProject"].includes(key)) {
            this[key] = value;
        }
        else if (["email", "gender", "language", "postcode"].includes(key)) {
            this[key] =
                value;
        }
        else {
            // If not, we assign to answers
            this.answers[key] = value;
        }
    }
    setAnswers(newFields) {
        Object.entries(newFields).forEach(([key, value]) => {
            this.setAnswer(key, value);
        });
    }
    setCompleted() {
        this.completed = true;
    }
    get page() {
        return this.pageVisits[this.pageVisits.length - 1];
    }
    set page(newPage) {
        if (newPage.order === undefined)
            newPage.order = this.pageVisits.length;
        this.pageVisits.push(newPage);
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            this.id === null ? __classPrivateFieldGet(this, _Treesponse_instances, "m", _Treesponse_create).call(this) : __classPrivateFieldGet(this, _Treesponse_instances, "m", _Treesponse_update).call(this);
        });
    }
}
_Treesponse_apiInterface = new WeakMap(), _Treesponse_instances = new WeakSet(), _Treesponse_create = function _Treesponse_create() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!this.treesponder.saved) {
            yield this.treesponder.save();
        }
        const { publicId } = yield __classPrivateFieldGet(this, _Treesponse_apiInterface, "f").createTreesponse(this);
        this.id = publicId;
        return true;
    });
}, _Treesponse_update = function _Treesponse_update() {
    return __awaiter(this, void 0, void 0, function* () {
        yield __classPrivateFieldGet(this, _Treesponse_apiInterface, "f").updateTreesponse(this);
        return true;
    });
};
